module.exports = __webpack_public_path__ + "assets/img/login_img.a4e76876.png";